<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align: center;">Considering that this has been a one-man job, the only person(s) I can think of to extend thanks to, besides myself, is my publisher. After almost a decade of trying and rejection, finally, finally, you made it happen.</p>
<p style="text-align: center;">Thank you!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?60a46b3c